import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { dateToDateFormat } from "util";
import ModalPortal from "util/component/Modal";
import { Modal } from "util/component/Modal/Modal";
import axios from "util/axios";
import AsyncSelect from "react-select/async";
import '../styles.scss';
import { LuUser2 } from "react-icons/lu";
import { BiCalendar } from "react-icons/bi";
import { IoFilter } from "react-icons/io5";
import { IoSearchOutline } from "react-icons/io5";
import {useSelector} from "react-redux";

const customStyle = {
    option: (provided, state) => ({
        ...provided,
        paddingLeft: "4px",
        textAlign: "center",
        width: "100%",
        color: state.isDisabled ? "#CCC" : "#000",
        backgroundColor: state.isFocused ? "#EEEEFF" : "#FFF",
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: "#555",
        textAlign: "center",
    }),
    menu: (provided, state) => ({
        ...provided,
        width: "max-content",
        minWidth: "100%",
        zIndex: 20,
        backgroundColor: "#FFF",
    }),
    control: (provided, state) => ({
        ...provided,
        borderColor: "#000",
        backgroundColor: "transparent",
        boxShadow: "none",
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        padding: "",
    }),
    placeholder: (provided, state) => ({
        ...provided,
        textAlign: "center",
        paddingRight: "5px",
        color: state.isDisabled ? "transparent" : "#CCC",
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: "4px",
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        marginBottom: 0,
        marginTop: 0,
    }),
};

const SelectBox = ({ api, value, onChange, geneCode, assign, login }) => {
    const filterOption = (data, inputValue) => {


        const assignUser = data?.user?.filter((i) => i.value === login)

        if(assignUser.length === 0 || data.reviewEnd ==="Y"){
            const startButton = document.getElementsByClassName("review-start-wrapper");
            startButton[0].firstChild.disabled = true;
            startButton[0].firstChild.style.cursor="not-allowed";
            startButton[0].firstChild.style.opacity="0.6";
        }

        return data?.user?.filter(
            (i) =>
                i.label?.toLowerCase().includes(inputValue.toLowerCase()) ||
                i.value?.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const promiseOptions = (inputValue) =>
        new Promise((resolve) => {
            axios.post(process.env.REACT_APP_API + api, {geneCode, assign})
                .then((Response) => { Response = Response.data.data.result;
                resolve(filterOption(Response, inputValue));
            });
        });

    return (
        <AsyncSelect
            cacheOptions
            loadOptions={promiseOptions}
            defaultOptions
            className={"searchable-dropdown"}
            styles={customStyle}
            value={value}
            onChange={onChange}
            isClearable
            geneCode={geneCode}
        />
    );
};

const SearchBox = (props) => {
    const { comment, filterAction } = props;
    const { t } = useTranslation(["page"]);
    const [dateRange, setDateRange] = useState([new Date().setMonth(new Date().getMonth() - 1), new Date().getTime()]);
    const [search, setSearch] = useState({ user: "", auth: null, search: "", external: ""});
    const [startDate, endDate] = dateRange;
    const [openDate, setOpenDate] = useState(false);
    const [alert, setAlert] = useState(false);
    const userSelector = useSelector((store) => store.user);
    const externalAuth = userSelector.userAuth.filter((f) => f.code === "20")

    const apiCallHandler = () => {
        const el = document.getElementById("Unconfirmed").checked;
        const external = document.getElementById("external")?.checked;
        const [prev, next] = dateRange;

        filterAction(search,prev,next,el,external);
    };

    const onSubmitSearch = (e) => {
        if (e.key === "Enter") {
            apiCallHandler()
        }
    };

    const onChangeValidate = (data) => {
        const [prev, next] = data;
        if (prev && next) {
            setOpenDate(false);
        }
        setDateRange(data);
    };

    const userChanged = (data) => {
        setSearch((OLD) => ({ ...OLD, user: data }));
    };

    const searchChanged = (data) => {
        setSearch((OLD) => ({ ...OLD, search: data }));
    };

    useEffect(() => {
        apiCallHandler();
    }, [comment]);

    return (
        <>
            <section className={`unconfirmed`}>
                <div className={`search-box`}>
                    <div className={`search-box-item`}>
                        <label htmlFor={"userSelector"} className={`icon-label`} style={{width: "3.5rem"}} >
                            <LuUser2 />
                        </label>
                        <div className={`input-group v2`}>
                            <SelectBox api={"/pcsReview/retrieveReviewRound"} onChange={userChanged}
                                       value={search.userNm} geneCode={comment.doc.revInfo.geneCode} assign={"Y"} login={userSelector.userId}/>
                        </div>
                        <div className={`input-group`}>
                            <div className={`radio-group`}>
                                <input
                                    type="checkbox"
                                    id={`Unconfirmed`}
                                    name={`UnconfirmedList`}
                                    checked={search.auth}
                                    onClick={() => {
                                        apiCallHandler(null);
                                    }}
                                />
                                <label htmlFor={`userTypeAll`}>Unconfirmed</label>
                            </div>
                            {externalAuth?.length === 0 ? (
                                <div className={`radio-group`}>
                                    <input
                                        type="checkbox"
                                        id={`external`}
                                        name={`external`}
                                        checked={search.auth}
                                        onClick={() => {
                                            apiCallHandler(null);
                                        }}
                                    />
                                    <label htmlFor={`externalSend`}>External</label>
                                </div>
                            ): null
                            }
                        </div>
                    </div>
                    <div className={`search-box-item`}>
                        <label htmlFor={"dateSelector"} className={`icon-label`}>
                            <BiCalendar/>
                        </label>
                        <div className={`input-group`}>
                            <input
                                type="text"
                                id={"dateSelector"}
                                readOnly
                                className={`date-selector`}
                                onFocus={(e) => {
                                    e.target.blur();
                                    setOpenDate(!openDate);
                                }}
                                value={`${dateToDateFormat(startDate, true)} ${
                                    endDate ? `~ ${dateToDateFormat(endDate, true)}` : ""
                                }`}
                            />
                            {openDate && (
                                <div style={{position: "absolute", width: "max-content", zIndex: "20"}}>
                                    <DatePicker
                                        selectsRange
                                        inline
                                        dateFormat="yyyy/MM/dd"
                                        monthsShown={2}
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={onChangeValidate}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={`search-box-item`}>
                        <label htmlFor={"userSelector"} className={`icon-label`}>
                            <IoFilter />
                        </label>
                        <div className={`input-group  v2`}>
                             <input type="text" value={search.search.value} onChange={searchChanged} onKeyDown={onSubmitSearch} style={{height: "35px"}} />
                        </div>
                        <div className={`btn-box`}>
                            <button className={`bpl-btn`} onClick={apiCallHandler}>
                            <IoSearchOutline />Search
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {alert && (
                <ModalPortal>
                    <Modal onClose={() => setAlert(false)}>{t("selectYear1")}</Modal>;
                </ModalPortal>
            )}
        </>
    );
};

export default SearchBox;
